import { Trans } from "@lingui/macro";
import { useMediaQuery, useTheme } from "@mui/material";
import { UiButton } from "@smp/ui";
import { IconWand } from "@tabler/icons-react";
import { FC } from "react";

import { useDialog } from "@/hooks/use_dialog";
import { useMePermissions } from "@/hooks/use_me_permissions";
import { DialogAdvisor } from "@/screens/app/components/dialogs/dialog_advisor";

import classes from "./advisor.module.css";

export interface IAdvisorProps {}

export const Advisor: FC<IAdvisorProps> = () => {
  const theme = useTheme();
  const isTablet = useMediaQuery(theme.breakpoints.down("md"));

  const permissions = useMePermissions();

  const {
    isOpen: isDialogOpen,
    open: openDialog,
    close: closeDialog,
  } = useDialog();

  if (!permissions.advisor) {
    return null;
  }

  return (
    <>
      <UiButton
        variant="contained"
        color="white"
        size="medium"
        className={classes.btn}
        onClick={openDialog}
      >
        <IconWand />
        {!isTablet && <Trans>AI SMM assistant</Trans>}
      </UiButton>

      <DialogAdvisor
        isOpen={isDialogOpen}
        onClose={closeDialog}
        onSuccess={closeDialog}
      />
    </>
  );
};
